export default __webpack_public_path__ + "static/media/logo-blast-media.a9017458.svg";